module.exports = __webpack_public_path__ + "img/news_01.807006c4.jpg";